module.exports = __webpack_public_path__ + "static/img/IsaacHeeney.a44a268.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/IsaacHeeney.jpg
// module id = 0KTE
// module chunks = 0